import { render, staticRenderFns } from "./DocsDetails.vue?vue&type=template&id=759c2a00&scoped=true&"
import script from "./DocsDetails.vue?vue&type=script&lang=js&"
export * from "./DocsDetails.vue?vue&type=script&lang=js&"
import style0 from "./DocsDetails.vue?vue&type=style&index=0&id=759c2a00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759c2a00",
  null
  
)

export default component.exports